import { useRef } from "react";
import { PlaylistItemDTO } from "../../lib/types";
import { cn } from "@/lib/utils";

type Props = {
  item: PlaylistItemDTO;
  onVideoEnded: () => void;
  isFullScreen?: boolean;
};

export const DSPlayerVideo: React.FC<Props> = ({ item, onVideoEnded, isFullScreen }) => {
  const ref = useRef<HTMLVideoElement>(null);

  const onTimeUpdate = (currentTime: number) => {
    // If the current time is greater than the duration, pause the video and call onVideoEnded
    if (currentTime > item.duration && item.duration > 0) {
      ref.current?.pause();
      onVideoEnded();
    }
  };

  return (
    <video
      ref={ref}
      id={item.id.toString()}
      src={item.src}
      muted
      autoPlay={false}
      controls={false}
      loop={false}
      style={{ width: "100%", height: "100%" }}
      className={cn("ds-player-video", isFullScreen && "with-full-screen")}
      onEnded={() => onVideoEnded()}
      onTimeUpdate={(event) => {
        if (event.target instanceof HTMLVideoElement && typeof event.target.currentTime !== "undefined") {
          onTimeUpdate(Number(event.target.currentTime));
        }
      }}
    />
  );
};
